<div ng-controller="userSettingsController as ctrl" class="modal-view user-settings">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>